// src/components/PasswordReset/PasswordReset.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PasswordReset.css';

const PasswordReset = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();

            if (response.ok) {
                setMessage(data.message);
                setTimeout(() => navigate('/'), 5000); // Redirect to home after 5 seconds
            } else {
                setMessage(data.error || 'Something went wrong. Please try again.');
            }
        } catch (error) {
            setMessage('An error occurred while sending the reset request.');
        }
    };

    return (
        <div className="password-reset-container">
            <h1 className="password-reset-title">Password Reset</h1>
            <p className="reset-instructions">
                Forgotten your password? Enter your e-mail address below, and we'll send you an e-mail allowing you to reset it.
            </p>
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Enter your email address"
                    className="email-input"
                />
                <button type="submit" className="reset-button">Reset My Password</button>
            </form>
            {message && <div className="reset-message">{message}</div>}
        </div>
    );
};

export default PasswordReset;
